<div class="loading-evaluation" *ngIf="loadingEvaluations">
    <loading></loading>
    <span>{{ 'session-details.evaluations.loading' | translate }}</span>
</div>
<div id="evaluations" *ngIf="!loadingEvaluations && evaluations.length > 0">
    <h2 class="row">
        {{ 'session-details.evaluations.studentEvaluations' | translate }}
        <button class="btn btn-link" title="Recharger" (click)="loadEvaluations()"><span class="fa fa-rotate-right"></span></button>
    </h2>
    <div class="row">
        <button
            class="standard-margin btn btn-default doc-buttons"
            (click)="
                downloadEvaluations(
                    sessionId,
                    'EVALUATION',
                    'application/pdf',
                    'evaluations.pdf'
                )
            "
        >
            {{ 'session-details.evaluations.downloadPDF' | translate }}
        </button>

        <button
            class="standard-margin btn btn-default doc-buttons"
            (click)="
                downloadEvaluations(
                    sessionId,
                    'EVALUATION_EMPTY',
                    'application/pdf',
                    'evaluations-empty.pdf'
                )
            "
        >
            ({{ 'session-details.evaluations.blankSheet' | translate }})
        </button>
        <br />
        <br />
    </div>
    <div class="row">
        <br />
        <h3 class="rating-category">
            {{ 'session-details.evaluations.trainer' | translate }}
        </h3>
        <div class="col-md-2">
            <div class="rating-text">
                {{ 'session-details.evaluations.trainerKnowledge' | translate }}
            </div>
            <div class="rating">
                {{ evaluationsAvg.trainerSubjectKnowledge }}
            </div>
        </div>
        <div class="col-md-2">
            <div class="rating-text">
                {{ 'session-details.evaluations.trainerTeaching' | translate }}
            </div>
            <div class="rating">
                {{ evaluationsAvg.trainerPedagogicalQuality }}
            </div>
        </div>
        <div class="col-md-2">
            <div class="rating-text">
                {{ 'session-details.evaluations.trainerAnswers' | translate }}
            </div>
            <div class="rating">{{ evaluationsAvg.trainerAnswerQuality }}</div>
        </div>
        <div class="col-md-2">
            <div class="rating-text">
                {{
                    'session-details.evaluations.trainerAvailability'
                        | translate
                }}
            </div>
            <div class="rating">{{ evaluationsAvg.trainerAvailability }}</div>
        </div>
    </div>
    <hr />
    <div class="row">
        <h3 class="rating-category">
            {{ 'session-details.evaluations.training' | translate }}
        </h3>
        <div class="col-md-2">
            <div class="rating-text">
                {{ 'session-details.evaluations.trainingContent' | translate }}
            </div>
            <div class="rating">
                {{ evaluationsAvg.trainingContentRichness }}
            </div>
        </div>
        <div class="col-md-2">
            <div class="rating-text">
                {{ 'session-details.evaluations.trainingLayout' | translate }}
            </div>
            <div class="rating">{{ evaluationsAvg.trainingLayout }}</div>
        </div>
        <div class="col-md-2">
            <div class="rating-text">
                {{ 'session-details.evaluations.trainingRatio' | translate }}
            </div>
            <div class="rating">
                {{ evaluationsAvg.trainingTheoryPracticeRatio }}
            </div>
        </div>
        <div class="col-md-2">
            <div class="rating-text">
                {{ 'session-details.evaluations.trainingExamples' | translate }}
            </div>
            <div class="rating">{{ evaluationsAvg.trainingExamples }}</div>
        </div>
        <div class="col-md-2">
            <div class="rating-text">
                {{ 'session-details.evaluations.trainingLabs' | translate }}
            </div>
            <div class="rating">
                {{ evaluationsAvg.trainingPracticeInterest }}
            </div>
        </div>
    </div>
    <hr />
    <div class="row margin-bottom-30">
        <h3 class="rating-category">
            {{ 'session-details.evaluations.freeInput' | translate }}
        </h3>
        <div class="col-md-2">
            <div class="rating-text">
                {{ 'session-details.evaluations.appropriateLevel' | translate }}
            </div>
            <div class="rating">{{ evaluationsPer.levelAdapted }} %</div>
        </div>
        <div class="col-md-2">
            <div class="rating-text">
                {{ 'session-details.evaluations.satisfied' | translate }}
            </div>
            <div class="rating">{{ evaluationsPer.satisfied }} %</div>
        </div>
    </div>

    <div class="row detailed-list">
        <div
            *ngFor="let evaluation of evaluations; let i = index"
            class="col-sm-12 eval-block"
        >
            <div>
                <div class="row">
                    <div class="col-md-12">
                        <p>
                            <i class="fa fa-user" style="margin-right:10px;"></i
                            ><span class="student-name"
                                >{{ evaluation.student.firstName }}
                                {{ evaluation.student.lastName }}</span
                            >
                            <span class="contact-checkbox">
                                <label class="checkbox-inline">
                                    <input
                                        type="checkbox"
                                        [checked]="evaluation.contactForTraining"
                                        style="margin-right:10px;"
                                        disabled
                                    />
                                        {{
                                            'session-details.evaluations.contactForTraining'
                                                | translate
                                        }}
                                </label>
                                <label class="checkbox-inline">
                                    <input
                                        type="checkbox"
                                        [checked]="evaluation.contactForAudit"
                                        style="margin-right:10px;"
                                        disabled
                                    />
                                        {{
                                            'session-details.evaluations.contactForAudit'
                                                | translate
                                        }}
                                </label>
                                <label class="checkbox-inline">
                                    <input
                                        type="checkbox"
                                        [checked]="evaluation.contactForJobs"
                                        style="margin-right:10px;"
                                        disabled
                                    />
                                        {{
                                            'session-details.evaluations.contactForJobs'
                                                | translate
                                        }}
                                </label>
                                <label class="checkbox-inline">
                                    <input
                                        type="checkbox"
                                        [checked]="evaluation.contactForEvents"
                                        style="margin-right:10px;"
                                        disabled
                                    />
                                        {{
                                            'session-details.evaluations.contactForEvents'
                                                | translate
                                        }}
                                </label>
                            </span>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <i class="fa fa-phone" style="margin-right:10px;"></i>
                        <a href="tel:{{ evaluation.student.phone }}">{{
                            evaluation.student.phone
                        }}</a
                        ><span *ngIf="!evaluation.student.phone">{{
                            'session-details.evaluations.blank' | translate
                        }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <i
                            class="fa fa-envelope"
                            style="margin-right:10px;"
                        ></i>
                        <a
                            href="mailto:{{ evaluation.student.email }}"
                            target="_top"
                            >{{ evaluation.student.email }}</a
                        ><span *ngIf="!evaluation.student.email">{{
                            'session-details.evaluations.blank' | translate
                        }}</span>
                    </div>
                </div>
            </div>

            <div class="row">
                <h3 class="rating-category-small">
                    {{ 'session-details.evaluations.trainer' | translate }}
                </h3>
                <div class="col-md-2">
                    <div class="rating-text">
                        {{
                            'session-details.evaluations.trainerKnowledge'
                                | translate
                        }}
                    </div>
                    <div class="rating-small">
                        {{ evaluation.trainerSubjectKnowledge }}
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="rating-text">
                        {{
                            'session-details.evaluations.trainerTeaching'
                                | translate
                        }}
                    </div>
                    <div class="rating-small">
                        {{ evaluation.trainerPedagogicalQuality }}
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="rating-text">
                        {{
                            'session-details.evaluations.trainerAnswers'
                                | translate
                        }}
                    </div>
                    <div class="rating-small">
                        {{ evaluation.trainerAnswerQuality }}
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="rating-text">
                        {{
                            'session-details.evaluations.trainerAvailability'
                                | translate
                        }}
                    </div>
                    <div class="rating-small">
                        {{ evaluation.trainerAvailability }}
                    </div>
                </div>
            </div>
            <div class="row">
                <h3 class="rating-category-small">
                    {{ 'session-details.evaluations.training' | translate }}
                </h3>
                <div class="col-md-2">
                    <div class="rating-text">
                        {{
                            'session-details.evaluations.trainingContent'
                                | translate
                        }}
                    </div>
                    <div class="rating-small">
                        {{ evaluation.trainingContentRichness }}
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="rating-text">
                        {{
                            'session-details.evaluations.trainingLayout'
                                | translate
                        }}
                    </div>
                    <div class="rating-small">
                        {{ evaluation.trainingLayout }}
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="rating-text">
                        {{
                            'session-details.evaluations.trainingRatio'
                                | translate
                        }}
                    </div>
                    <div class="rating-small">
                        {{ evaluation.trainingTheoryPracticeRatio }}
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="rating-text">
                        {{
                            'session-details.evaluations.trainingExamples'
                                | translate
                        }}
                    </div>
                    <div class="rating-small">
                        {{ evaluation.trainingExamples }}
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="rating-text">
                        {{
                            'session-details.evaluations.trainingLabs'
                                | translate
                        }}
                    </div>
                    <div class="rating-small">
                        {{ evaluation.trainingPracticeInterest }}
                    </div>
                </div>
            </div>
            <hr />
            <div class="row">
                <h3 class="rating-category-small">
                    {{ 'session-details.evaluations.freeInput' | translate }}
                </h3>
                <div class="col-md-3">
                    <div class="rating-text">
                        {{
                            'session-details.evaluations.otherSubjects'
                                | translate
                        }}
                    </div>
                    <div class="rating-text bold">
                        {{ evaluation.subjectsInterestedIn }}
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="rating-text">
                        {{ 'session-details.evaluations.comments' | translate }}
                    </div>
                    <div class="rating-text bold">
                        {{ evaluation.comments }}
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="rating-text">
                        {{
                            'session-details.evaluations.mostLiked' | translate
                        }}
                    </div>
                    <div class="rating-text bold">
                        {{ evaluation.subjectMostAppreciated }}
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="rating-text">
                        {{
                            'session-details.evaluations.leastLiked' | translate
                        }}
                    </div>
                    <div class="rating-text bold">
                        {{ evaluation.subjectLeastAppreciated }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="no-evaluation" *ngIf="!loadingEvaluations && evaluations.length === 0">
    <h2>
        {{ 'session-details.evaluations.noEvaluation' | translate }}
        <button class="btn btn-link" title="Recharger" (click)="loadEvaluations()"><span class="fa fa-rotate-right"></span></button>
    </h2>

    <button
        class="standard-margin btn btn-default doc-buttons"
        (click)="
            downloadEvaluations(
                sessionId,
                'EVALUATION_EMPTY',
                'application/pdf',
                'evaluations-empty.pdf'
            )
        "
    >
        {{ 'session-details.evaluations.downloadBlankSheet' | translate }}
    </button>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/evaluations/evaluations.component.html